module.exports = __webpack_public_path__ + "img/sucot-2015-thumbnail.386e9a2b.jpeg";